var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;

var _react=_interopRequireDefault(require("react"));
var _reactNative=require("react-native");
var _router=require("@reach/router");
var _Api=require("../Api");
var _Icon=_interopRequireDefault(require("../Icon"));var _this=this,_jsxFileName="/Users/paveljacko/DEV/Code/renative2/packages/renative/src/Button/index.web.js";

var styles=_reactNative.StyleSheet.create({
button:{
flexDirection:'row',
opacity:1,
alignItems:'center',
justifyContent:'center'},

icon:{
marginRight:(0,_Api.getScaledValue)(20)}});



var Button=function Button(_ref)












{var focused=_ref.focused,to=_ref.to,title=_ref.title,iconFont=_ref.iconFont,iconName=_ref.iconName,iconColor=_ref.iconColor,iconSize=_ref.iconSize,style=_ref.style,textStyle=_ref.textStyle,onPress=_ref.onPress,activeOpacity=_ref.activeOpacity,testID=_ref.testID;
var Btn=function Btn(){return(
_react.default.createElement(_reactNative.TouchableOpacity,{
style:[styles.button,style,focused?{opacity:activeOpacity!=null?activeOpacity:0.4}:null],
onPress:onPress,
testID:testID,__self:_this,__source:{fileName:_jsxFileName,lineNumber:36,columnNumber:9}},

iconName?
_react.default.createElement(_Icon.default,{
iconFont:iconFont,
iconName:iconName,
iconColor:iconColor,
size:iconSize,
style:[styles.icon,{
marginRight:title?(0,_Api.getScaledValue)(20):0}],__self:_this,__source:{fileName:_jsxFileName,lineNumber:42,columnNumber:17}}):


null,
title?
_react.default.createElement(_reactNative.Text,{style:textStyle,__self:_this,__source:{fileName:_jsxFileName,lineNumber:53,columnNumber:17}},
title):

null));};


if(to){
return(
_react.default.createElement(_router.Link,{
to:to,
getProps:function getProps(_ref2){var isCurrent=_ref2.isCurrent;return{
style:{
color:isCurrent?'white':'transparent'}};},__self:_this,__source:{fileName:_jsxFileName,lineNumber:61,columnNumber:13}},



_react.default.createElement(Btn,{__self:_this,__source:{fileName:_jsxFileName,lineNumber:69,columnNumber:17}})));


}
return _react.default.createElement(Btn,{__self:_this,__source:{fileName:_jsxFileName,lineNumber:73,columnNumber:12}});
};var _default=

Button;exports.default=_default;
//# sourceMappingURL=index.web.js.map